import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { CartDiscountSelector } from "./CartDiscountSelector.js";
import { useCartDiscountsQuery } from "../../../../../../../../hooks/useCartDiscountsQuery/hooks/useCartDiscountsQuery/use-cart-discounts-query.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
const CartDiscountSelectorContainer = ({
  className,
  selectedQuantity,
  onCartDiscountSelection,
  onCartDiscountReset
}) => {
  const { isCartDiscountsEnabled } = useFeatureToggles();
  const {
    activeVariant: { promotionIdentifier }
  } = useProductData();
  const { cartDiscounts, activeDiscount, loading } = useCartDiscountsQuery(
    promotionIdentifier,
    selectedQuantity
  );
  if (!isCartDiscountsEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    CartDiscountSelector,
    {
      className,
      cartDiscountItems: cartDiscounts,
      isLoading: loading,
      onItemClick: onCartDiscountSelection,
      onReset: onCartDiscountReset,
      activeDiscount
    }
  );
};
export {
  CartDiscountSelectorContainer
};
//# sourceMappingURL=CartDiscountSelectorContainer.js.map
